import { LayerOrientation } from "@buildwithflux/models";
import { metersToMm, normalizeRadians } from "@buildwithflux/shared";
import { Vector2 } from "three";
import { ZeroVector2 } from "../../../../../common";
/**
 * Wraps metersToMm to avoid floating point errors without losing valuable precision for KiCad export
 * @param meters value in meters
 * @returns value in milimeters, fixed to max 14 decimal places (e.g. 11.732600000000001 becomes 11.7326)
 */
export function toMm(meters) {
    return Number(metersToMm(meters ?? 0).toFixed(14));
}
export function getModule(layerName, context) {
    return layerName === LayerOrientation.top ? context.rootModules.top : context.rootModules.bottom;
}
function getFlippedAxes(rotationVector) {
    // calculated rotation vectors can end up with either the x or the y axis flipped,
    // even if we only flipped around the y axis in the code, because the inverse world-space
    // transformation has multiple possible answers (eg y=180,z=45 is equivalent to x=180,z=135).
    // So we check both.
    const normX = normalizeRadians(rotationVector.x, true);
    const normY = normalizeRadians(rotationVector.y, true);
    return {
        xFlip: Math.abs(normX) > Math.PI / 2,
        yFlip: Math.abs(normY) > Math.PI / 2,
    };
}
export function getRotatedPosition(fromPosition, rotationVector, rotateCounterClockwise = false) {
    const position = new Vector2(fromPosition.x, fromPosition.y);
    position.rotateAround(ZeroVector2, rotateCounterClockwise ? -rotationVector.z : rotationVector.z);
    const { xFlip, yFlip } = getFlippedAxes(rotationVector);
    if (xFlip) {
        position.setY(-position.y);
    }
    if (yFlip) {
        position.setX(-position.x);
    }
    return position;
}
/**
 * Temporary solution for angle decimal precision issues.
 * TODO: Remove once we stop truncating radians.
 */
export function fixAngleDecimals(angle, maxDecimals = 2) {
    return Number(angle.toFixed(maxDecimals));
}
//# sourceMappingURL=utils.js.map